<template>
  <div class="row">
    <loading :active.sync="isLoading" :can-cancel="true" :opacity="0.85" :is-full-page="true"></loading>
    <div class="col-12">
      <card
        :title="title"
        :subTitle="subTitle"
        :showFilter="showFilter"
        @doFilter="doFilter"
        :filterInputValue="filterTerm"
      >
        <div slot="raw-content" class="table-responsive">
          <paper-table
            :data="data"
            :columns="columns"
            :hasActions="hasActions"
            :actions="actions"
            :totalItems="totalItems"
            @changePage="changePage"
          />
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import utils from "@/utils";
import odata from "@/services/odata.vue";

import moment from "moment";
import { PaperTable } from "@/components";

const tableColumns = ["Asset", "Date", "User", "Action"];

export default {
  components: {
    PaperTable,
    Loading
  },
  props: {},
  watch: {},
  data() {
    return {
      title: "Services",
      subTitle: `All ${store.getters.selectedCustomer.CustomerName} services are listed below`,
      actions: {},
      hasActions: false,
      columns: [...tableColumns],
      data: [],
      isLoading: false,
      currentPage: 1,
      totalItems: 1,
      showFilter: true,
      filterTerm: ""
    };
  },
  mounted() {
    this.loadPage(1);
  },
  methods: {
    changePage(pageNum) {
      this.currentPage = pageNum;
      this.loadPage(pageNum);
    },
    doFilter(filter) {
      this.filterTerm = filter;
      this.loadPage(1);
    },
    refreshData() {
      this.loadPage();
    },
    hideLoadingAtNextTick() {
      Vue.nextTick(() => {
        this.isLoading = false;
      });
    },

    loadPage(num) {
      if (!num) num = this.currentPage;

      this.isLoading = true;
      let params = {
        entity: "assetservice",
        path: "",
        perPage: 10,
        page: num,
        orderby: "ActionDate desc",
        filterFields: ["AssetId", "ServiceAction", "Username"],
        filterValue: this.filterTerm
        //select: ['Id', 'ServiceAction', 'Username', 'ActionDate']
        //expand: 'User'
      };
      odata
        .getPaged(params)
        .then(resp => {
          this.totalItems = resp.data.count;
          this.data = resp.data.results.map(val => {
            return {
              asset: utils.getTypeHtml(val.assetType, val.tagNo),
              id: val.id,
              tagNo: val.tagNo,
              action: val.serviceActionString,
              user: val.username,
              date: moment(val.actionDate).format("D-MMM-YYYY HH:mm")
            };
          });
          this.hideLoadingAtNextTick();
        })
        .catch(err => {
          this.hideLoadingAtNextTick();
          if (err.response.status === 401) return;
          this.$helpers.dispatch("showError", {
            msg: "Unexpected error occurred",
            vm: this
          });
        });
    }
  }
};
</script>

<style>
</style>
